import { globalCss } from '@grupoboticario/flora';

import { getLocationPathname } from '../helpers';

export const insertScriptToHiddenRecaptcha = () => {
  const path = '/login';
  const currentPath = getLocationPathname();

  if (path !== currentPath) {
    const globalStyles = globalCss({
      'div>.grecaptcha-badge': {
        display: 'none!important',
      },
    });
    globalStyles();
  }
};
